import HStack from "shared/components/layout/stack/HStack";
import { mediaQueries } from "shared/config/breakpoints";
import styled from "styled-components/macro";

export const LoadingWrapper = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: grid;
    justify-content: center;
    align-content: center;
`;

export const MainPageContent = styled.div`
    position: relative;
    width: 100%;
    padding-top: ${(props) => props.paddingTop ?? "32px"};
    padding-right: 64px;
    padding-bottom: ${(props) => props.paddingBottom ?? "32px"};
    padding-left: 64px;
    min-height: ${(props) => props.minHeight ?? "calc(100vh - 5rem - 3.5rem)"};
    top: ${(props) => props.positionOfWrapper ?? "0"};

    ${mediaQueries.small} {
        padding-right: 16px;
        padding-left: 16px;
        padding-top: ${(props) => props.paddingTop ?? "32px"};
        padding-bottom: ${(props) => props.paddingBottom ?? "24px"};
    }
`;

export const SideNavSection = styled.div`
    flex-shrink: 0;
    z-index: 2;
`;

export const TabsSection = styled.div`
    width: 100%;
    z-index: 1;
`;

export const ResponsiveHStack = styled(HStack)`
    ${mediaQueries.small} {
        gap: 24px;
    }
`;
